<template>
    <div class="row">

        <div class="card-body">
            <div class="alert alert-warning" role="alert" v-for="(alert,index) in validate" :key="index">
                <i data-feather="alert-circle"></i>
                {{alert}}
            </div>
            <button class="btn btn-success btn-icon text-white fw-bolder btn-icon-text float-end" @click="addDokumen()"
                type="button"> <i class="mdi mdi-folder-plus"></i> </button>

            <br>
            <br>
            <br>

            <vue-good-table title="list-dokumen-impor" :totalRows="totalRecordsDokumen" :rows="rowsDokumen"
                :columns="columnsDokumen"
                :pagination-options="{
                    enabled: true,
                    perPage: 10,
                    perPageDropdown: [10, 50, 100],
                }"
                :line-numbers="true"
                >
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'actions'">

                        <a href="#" v-if="forms.status != 'FINISH'" title="Edit"
                            @click.prevent="editDataDokumen(props.row)">
                            <i class="mdi mdi-square-edit-outline" style="font-size:16px;color:#66d1d1;"></i>
                        </a>

                        <a href="#" v-if="forms.status != 'FINISH'" title="Delete"
                            @click.prevent="deleteDataDokumen(props.index, props.row)">
                            <i class="mdi mdi-delete-forever" style="font-size:16px;color:red;"></i>

                        </a>
                    </span>
                    <span v-else-if="props.column.field == 'urlDokumen'">
                        <a href="#" v-if="props.row.urlDokumen" title="Download"
                            @click.prevent="downloadFileDokumen(props.row)">
                            <i class="mdi mdi-briefcase-download" style="font-size:16px;color:#1da891;"></i>
                        </a>
                        <a href="#" v-if="props.row.urlDokumen" title="Delete"
                            @click.prevent="deleteFileDokumen(props.row)">
                            <i class="mdi mdi-bookmark-remove" style="font-size:16px;color:red;"></i>
                        </a>
                    </span>

                    <span v-else-if="props.column.field == 'jenisDokumen'">
                        {{ props.row.kodeDokumen + " - "+props.row.namaDokumen }}
                    </span>

                    <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
            </vue-good-table>

        </div>

        <dokumentAdd :seriNo="docSeriNo" :docId="forms.document_id" @setValue="refreshData"></dokumentAdd>
        <dokumentEdit :docForm="passDataEdit" :docId="forms.document_id" @setValue="refreshData"></dokumentEdit>

    </div>
</template>

<script>
import dokumentAdd from "@/components/exim/ceisa/barang_impor/modal/modalDokumenAdd.vue";
import dokumentEdit from "@/components/exim/ceisa/barang_impor/modal/modalDokumenEdit.vue";
export default {
    name: "CeisaDokumen",
    props: {
        propsData: { type: [Object, Array] },
        validate: { type: [Object, Array, String] }
    },
    components: {
        dokumentAdd,
        dokumentEdit
    },
    data() {
        return {
            forms: [],
            totalRecordsDokumen: 0,
            docSeriNo: 0,
            rowsDokumen: [],
            columnsDokumen: [
                // {
                //     label: this.$t('seri'),
                //     field: 'seriDokumen',
                //     type: 'number',
                //     thClass: 'text-center',
                //     filterOptions: {
                //         customFilter: false,
                //         enabled: true, // enable filter for this column
                //         placeholder: '', // placeholder for filter input
                //         filterValue: "", // initial populated value for this filter
                //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                //         trigger: "enter", //only trigger on enter not on keyup
                //     },
                // },
                {
                    label: this.$t('jenis_dokumen'),
                    field: 'jenisDokumen',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('nomorNya'),
                    field: 'nomorDokumen',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('tanggal'),
                    field: 'tanggalDokumen',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('fasilitas'),
                    field: 'kodeFasilitas',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('izin'),
                    field: 'kodeIjin',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('kantor'),
                    field: 'kodeKantor',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('file'),
                    field: 'urlDokumen',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: false, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },
            ],
            passDataEdit: [],

        }
    },
    methods: {
        editDataDokumen(row) {
            let fasilitas_dokumen = { code: row.kodeFasilitas, name: row.namaFasilitas, label: row.kodeFasilitas + " - " + row.namaFasilitas };
            let kode_dokumen = { code: row.kodeDokumen, name: row.namaDokumen, label: row.kodeDokumen + " - " + row.namaDokumen };
            let form_dokumen = { document_dokumen_id: row.document_dokumen_id, document_id: row.document_id, idDokumen: row.idDokumen, kodeDokumen: row.kodeDokumen, namaDokumen: row.namaDokumen, kodeFasilitas: row.kodeFasilitas, namaFasilitas: row.namaFasilitas, kodeIjin: row.kodeIjin, namaIjin: row.namaIjin, nomorDokumen: row.nomorDokumen, kodeKantor: row.kodeKantor, namaKantor: row.namaKantor, tanggalDokumen: row.tanggalDokumen, seriDokumen: row.seriDokumen, urlDokumen: row.urlDokumen };
            let fileDokumen = "";
            this.passDataEdit = {
                "fasilitas_dokumen": fasilitas_dokumen,
                "kode_dokumen": kode_dokumen,
                "form_dokumen": form_dokumen,
                "fileDokumen": fileDokumen,
            };
            this.$modal.show('editDokumen')
        },
        deleteDataDokumen(index, row) {

            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    const baseURI = this.$settings.endPointCeisa + "v1/document/delete-document-dokumen/" + row.document_dokumen_id;
                    this.$http
                        .delete(baseURI, { timeout: 10000 })
                        .then((response) => {
                            this.isLoading = false;
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.$emit("updateData");
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch((error) => {
                            this.isLoading = false;

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {


                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));

                                } else {

                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        } else {
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });

        },
        downloadFileDokumen(row) {

            this.isLoading = true;
            var fileName = row.urlDokumen;
            var file_name = fileName.substring(fileName.lastIndexOf("/") + 1)
            const baseURI = this.$settings.endPointCeisa + "v1/document/download-file-dokumen/" + row.document_dokumen_id;
            return this.$http
                .get(baseURI, {
                    responseType: "blob",
                })
                .then((response) => {
                    this.isLoading = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.isLoading = false;
                });

        },

        deleteFileDokumen(row) {

            this.isLoading = true;

            var id = row.document_dokumen_id;

            const baseURI = this.$settings.endPointCeisa + "v1/document/delete-file-dokumen/" + id;

            return this.$http.delete(baseURI, { timeout: 10000 }).then((response) => {

                this.isLoading = false;
                if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                }
                this.$emit("updateData");

            }).catch(error => {

                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });

        },
        refreshData() {
            this.success("Berhasil");
            this.$emit("updateData");
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
        reAssignValue() {
            this.rowsDokumen = this.forms.dokumen;

        },
        addDokumen() {
            this.docSeriNo = this.rowsDokumen.length + 1;
            this.$modal.show('createDokumen');
        }
    },
    watch: {
        propsData: function (newVal) {
            this.forms = newVal;
            this.reAssignValue();

        },
        forms: function (newVal) {
            this.$emit('formUpdate', newVal);
        },
    },
}
</script>

<style></style>